import { NgxSpinnerConfig } from 'ngx-spinner/lib/config';

export default {
  type: 'ball-clip-rotate'
} as NgxSpinnerConfig;